import React from 'react'

/**
 * Helpers and types
 */
import {pure} from '@react/store'
import {DefaultComponentProps} from '@interface/common'


/**
 * Oraganizations Screen
 */
export default pure(({store, modal}: {data:any} & DefaultComponentProps) => {
  var state = store.useLocalState({
    count: 0
  })


  React.useEffect(() => {
    var i = Math.floor(Math.random() * 50)

    const interval = setInterval(() => {
      if(i > 100) {
        modal.close()
        clearInterval(interval)
      }
      else {
        state.set({count: i})
      }
      i++
    }, 800)
  }, [])


  return (
    <div className="progress">
      <div className="percent" style={{width: `${state.count}%`}}/>
    </div>
  )
})